var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { bankIDApi } from "apis/eduidBankid";
import { eidasApi } from "apis/eduidEidas";
import { frejaeIDApi } from "apis/eduidFrejaeID";
import signupApi from "apis/eduidSignup";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { clearNotifications, showNotification } from "slices/Notifications";
import { signupSlice } from "slices/Signup";
const statusActions = {
    eidas: "eidas",
    samleid: "eidas",
    bankid: "bankid",
    freja_eid: "freja_eid",
};
function handleIdentityCollision(result, dispatch, app_name, authn_id) {
    var _a;
    if (!result.error)
        return;
    const error = result.error;
    if (((_a = error.payload) === null || _a === void 0 ? void 0 : _a.message) === "signup.identity-already-registered") {
        dispatch(clearNotifications());
        dispatch(signupSlice.actions.setIdentityCollision({ app_name, authn_id }));
    }
}
export function SignupExternalReturnHandler() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const is_configured = useAppSelector((state) => state.config.is_configured);
    const [externalMfaRegister] = signupApi.useLazyExternalMfaRegisterQuery();
    const [bankIDGetStatus] = bankIDApi.useLazyBankIDGetStatusQuery();
    const [eidasGetStatus] = eidasApi.useLazyEidasGetStatusQuery();
    const [frejaeIDGetStatus] = frejaeIDApi.useLazyFrejaeIDGetStatusQuery();
    const getStatusAction = useCallback((app_name) => {
        const actions = {
            eidas: eidasGetStatus,
            samleid: eidasGetStatus,
            bankid: bankIDGetStatus,
            freja_eid: frejaeIDGetStatus,
        };
        return actions[app_name];
    }, [eidasGetStatus, bankIDGetStatus, frejaeIDGetStatus]);
    const processStatus = useCallback((status, app_name, authn_id) => __awaiter(this, void 0, void 0, function* () {
        if (status.status) {
            dispatch(showNotification({ message: status.status, level: status.error ? "error" : "info" }));
        }
        if (!status.frontend_action)
            return;
        const result = yield externalMfaRegister({ app_name, authn_id });
        handleIdentityCollision(result, dispatch, app_name, authn_id);
        navigate("/register");
    }), [externalMfaRegister, dispatch, navigate]);
    const fetchStatus = useCallback((authn_id) => __awaiter(this, void 0, void 0, function* () {
        if (!params.app_name || !statusActions[params.app_name])
            return;
        const action = getStatusAction(params.app_name);
        if (!action)
            return;
        const response = yield action({ authn_id });
        if (response.isSuccess) {
            yield processStatus(response.data.payload, params.app_name, authn_id);
        }
    }), [params.app_name, getStatusAction, processStatus]);
    useEffect(() => {
        if (is_configured && params.authn_id) {
            fetchStatus(params.authn_id);
        }
    }, [params, is_configured, fetchStatus]);
    return null;
}
